import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import IMAGES from '../assets/index.js';

// --- Configuration for Google Drive API ---
const API_KEY = process.env.REACT_APP_GDRIVE_URI; 
const FOLDER_ID = '1wczB14cUzLrnYpissgGWrBWHB5IsJBKQ';

function Gallery() {
  const [driveImages, setDriveImages] = useState([]);
  const [slidesToShow, setSlidesToShow] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSlidesToShow(1);
      } else if (window.innerWidth < 1200) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    // Set initial value
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // This part is working correctly.
    const fetchImages = async () => {
      try {
        const response = await fetch(
          `https://www.googleapis.com/drive/v3/files?q='${FOLDER_ID}' in parents&key=${API_KEY}`
        );
        const data = await response.json();
        if (data.files) {
          const imageFiles = data.files.map(file => ({
            id: file.id,
            src: `https://drive.google.com/thumbnail?id=${file.id}&sz=w1000`,
            alt: file.name,
          }));
          setDriveImages(imageFiles);
        }
      } catch (error) {
        console.error('Error fetching images from Google Drive:', error);
      }
    };

    fetchImages();
  }, []);

  // Slider settings (JS part is correct)
  const sliderSettings = {
    dots: false, // Disable dots entirely to avoid clutter
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false, // Hide arrows on all devices
    swipe: true,
    touchMove: true,
  };

  // ==================== MORE AGGRESSIVE CSS FIX ====================
  // This CSS is more specific and uses !important to override other styles.
  const galleryStyles = `
    /* --- Image Sizing Fix --- */
    .slick-slide .gallery-card {
      /* Ensure the card takes up the full space */
      display: flex;
      flex-direction: column;
      height: 100%;
      margin: 0 5px; /* Add some spacing between slides */
    }

    .slick-slide .image-wrapper {
      position: relative;
      /* Using a fixed height on mobile can be more reliable */
      height: 300px !important; 
      padding-top: 0 !important; /* Override the aspect ratio hack from style.css */
      width: 100%;
      overflow: hidden;
      background-color: #222; /* Placeholder color */
      border-radius: 8px;
    }

    .slick-slide .gallery-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100% !important;
      height: 100% !important;
      /* Crucial: ensures the image covers the area without distortion */
      object-fit: cover !important; 
      object-position: center;
    }
  `;
  // =================================================================

  return (
    <>
      <style>{galleryStyles}</style>
      
      <div id="pictures" className="gallery-section" style={{ marginTop: "20px", padding: "20px 0" }}>
        <Container fluid>
          {/* Static images section is unchanged */}
          <Row className="gallery-row">
            <Col lg={4} md={6} sm={12} className="gallery-col mb-4">
              <div className="gallery-card">
                <div className="image-wrapper">
                  <img src={IMAGES.beg} alt="Yoga Practice" className="gallery-image" />
                </div>
              </div>
            </Col>
            <Col lg={4} md={6} sm={12} className="gallery-col mb-4">
              <div className="gallery-card">
                <div className="image-wrapper">
                  <img src={IMAGES.adv} alt="Advanced Yoga" className="gallery-image" />
                </div>
              </div>
            </Col>
            <Col lg={4} md={6} sm={12} className="gallery-col mb-4">
              <div className="gallery-card">
                <div className="image-wrapper">
                  <img src={IMAGES.intC} alt="Intermediate Class" className="gallery-image" />
                </div>
              </div>
            </Col>
          </Row>
          
          <div className="gallery-title mb-4">
            <h2 className="text-center">Our Yoga Day</h2>
            <span className="d-block text-center mb-3">Moments from our yoga community</span>
          </div>
          
          {/* Carousel section */}
          {driveImages.length > 0 ? (
            <Slider {...sliderSettings}>
              {driveImages.map(image => (
                <div key={image.id} className="p-2">
                  <div className="gallery-card">
                    <div className="image-wrapper">
                      <img src={image.src} alt={image.alt} className="gallery-image" />
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            <p className="text-center">Loading moments...</p>
          )}
          
          {/* View more button is unchanged */}
          <Row className="justify-content-center mt-3">
            <Col xs={12} className="text-center">
              <a 
                className="horizontal-btn" 
                href="https://drive.google.com/drive/folders/1wczB14cUzLrnYpissgGWrBWHB5IsJBKQ?usp=drive_link" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                View More Images
              </a>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Gallery;